import type { PickerSelectionSummary } from "./Picker.types";

export const defaultSelectionSummary: Required<PickerSelectionSummary> = {
    mode: "mixed",
    maxListed: 3,
};

/**
 * Multi-select summary text: `list` joins every label, `count` always reports
 * "N selected", `mixed` lists up to `maxListed` labels before counting.
 */
export const summarizeSelection = ({
    labels,
    summary = defaultSelectionSummary,
}: {
    labels: readonly string[];
    summary?: PickerSelectionSummary;
}): string | null => {
    if (labels.length === 0) {
        return null;
    }
    const maxListed = summary.maxListed ?? defaultSelectionSummary.maxListed;
    const shouldCount =
        summary.mode === "count" ||
        (summary.mode === "mixed" && labels.length > maxListed);
    return shouldCount ? `${labels.length} selected` : labels.join(", ");
};
